import { render, staticRenderFns } from "./Terms_of_Service.vue?vue&type=template&id=68c25408&scoped=true&"
import script from "./Terms_of_Service.vue?vue&type=script&lang=js&"
export * from "./Terms_of_Service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c25408",
  null
  
)

export default component.exports